import React from 'react';
import {Avatar, Tooltip} from '@mui/material';
import EditCloneDeleteMenu from "../../Menus/EditCloneDeleteMenu";
import ProductResidualsMenu from "./ProductResidulsMenu";



export const ProductGridColumns = ({ hideActions, onEdit, onClone, onDelete,    ResidualHeaderMenu,
                                       handleMousedRow,
                                        }) => [

    {
        field: "more",
        headerName: '',
        width: 20,
        sortable: false,
        filterable: false,
        hide: hideActions,
        renderCell: (params) => (
            <Tooltip title={`Click to see actions for record ${params.row.id}`}>
                <EditCloneDeleteMenu
                    onEdit={() => onEdit(params.row)}
                    onClone={() => onClone(params.row)}
                    onDelete={() => onDelete(params.row)}
                />
            </Tooltip>
        )
    },

    {
        field: 'paticipations',
        headerName: 'P',
        description: '',
        sortable: false,
        disableColumnMenu: true,  // Disable the column menu (three dots menu)
        width: 25,
        renderCell: (products) => {
            if (products.row.participations > 0) {
                // if(filteredCDP.row.mockIndicator==='f'){
                return (
                    <Tooltip enterDelay={1000} enterNextDelay={1000} title={"Participation contracts exist on this title"}>
                        <Avatar variant="rounded"
                                sx={{height: 20, width: 20, fontSize: 16, bgcolor: "rgb(30,144,255)"}}>Pa</Avatar>
                    </Tooltip>)
            }
            else {return(<p></p>)}
        }

    },
    {
        field: 'residuals',
        renderHeader: () => (

            <ResidualHeaderMenu  style={{cursor:'pointer'}} />
        ),
        headerName: 'Re',
        description: '',
        sortable: false,
        menu: false,
        filter: false,
        disableColumnMenu: true,  // Disable the column menu (three dots menu)
        width: 25,
        renderCell: (products) => (
            <div onMouseOver={() => handleMousedRow(products.row)}>
                <ProductResidualsMenu row={products.row} />
            </div>
        )

    },
    {
        field: 'royalties',
        headerName: 'Ro',
        description: '',
        sortable: false,
        disableColumnMenu: true,  // Disable the column menu (three dots menu)
        width: 25,
        renderCell: (products) => {
            if (products.row.royalties > 0) {
                // if(filteredCDP.row.mockIndicator==='f'){
                return (
                    <Tooltip enterDelay={1000} enterNextDelay={1000} title={"Royalties contracts exist on this title"}>
                        <Avatar variant="rounded"
                                sx={{height: 20, width: 20, fontSize: 16, bgcolor: "rgb(30,144,255)"}}>Ro</Avatar>
                    </Tooltip>)
            }
            else {return(<p></p>)}
        }
    },
    {    field: 'id',
        headerName: 'ID',
        sortable: true,
        width: 100,
    },
    {
        field: 'externalId',
        headerName: 'Product ID',
        sortable: true,
        // editable: true,
        width: 100,
    },
    {
        field: 'name',
        headerName: 'Name',
        sortable: true,
        // editable: true,
        width: 300,
    },
    {
        field: 'episodeName',
        headerName: 'Episode Name',
        sortable: true,
        // editable: true,
        width: 250,
    },
    {
        field: 'seriesExternalId',
        headerName: 'Series ID',
        sortable: true,
        width: 80,

    },
    {
        field: 'seriesName',
        headerName: 'Series Name',
        sortable: true,
        width: 250,

    },

    {
        field: 'seasonExternalId',
        headerName: 'Season ID',
        sortable: true,
        // editable: true,
        width: 80,
    },
    {
        field: 'season',
        headerName: '#',
        sortable: true,
        // editable: true,
        width: 40,
    },
    {
        field: 'seasonName',
        headerName: 'Season Name',
        sortable: true,
        // editable: true,
        width: 250,
    },


    {
        field: 'photoStartDate',
        headerName: 'Photo Start',
        sortable: true,
        width: 100,

    },
    {
        field: 'lengthMinutes',
        headerName: 'Length',
        sortable: true,
        width: 60,

    },
    {
        field: 'm4mktGroup',
        headerName: 'Made-For Market Group',
        sortable: true,
        width: 180,

    },
    {
        field: 'initMkt',
        headerName: 'Initial Market',
        sortable: true,
        width: 140,

    },
    {
        field: 'genre',
        headerName: 'Genre',
        sortable: true,
        width: 100,

    },
    {
        field: 'productionType',
        headerName: 'Production Type',
        sortable: true,
        width: 120,

    },
    {
        field: 'broadcastsPerWeek',
        headerName: 'Broadcasts Per Week',
        sortable: true,
        width: 180,

    },
    {
        field: 'budget',
        headerName: 'Budget',
        sortable: true,
        width: 100,

    },
    {
        field: 'productionCost',
        headerName: 'Production Cost',
        sortable: true,
        width: 150,

    },
    {
        field: 'producer',
        headerName: 'Producer',
        sortable: true,
        width: 100,

    },
    {
        field: 'financialCode',
        headerName: 'Financial Code',
        sortable: true,
        width: 150,

    },
    {
        field: 'eidr',
        headerName: 'EIDR',
        sortable: true,
        width: 150,

    },
    {
        field: 'derivativeOfProductId',
        headerName: 'Derivative Of Product',
        sortable: true,
        width: 200,

    },
    {
        field: 'derivativeOfSeriesId',
        headerName: 'Derivative of Series',
        sortable: true,
        width: 200,
    },
    {
        field: 'coveredProduct',
        headerName: 'Covered Product',
        sortable: true,
        width: 150,

    },
    {
        field: 'status',
        headerName: 'Status',
        sortable: true,
        width: 150,
    },
];
